<template>
  <div class="ProjectInfo">
    <div class="title" :style="`font-size: ${titleFontSize}px;`">进出人员记录</div>
    <div class="info">
      <div class="list" :style="`font-size: ${listFontSize}px;`">
        <div v-for="item in personList" :key="item.recordId" class="item">
          <div class="topInfo">
            <div class="img"><img :src="item.recordPhotoUrl || personAvatar" alt="" /></div>
            <div class="userInfo">
              <div class="txt">{{ item.personName }}</div>
              <div class="txt">{{ item.teamName }}</div>
              <div class="txt">{{ item.workerTypeName }}</div>
            </div>
            <div class="idenInfo">
              <div class="txt">{{ item.idcardNumber }}</div>
            </div>
            <div class="inOutInfo">
              <div class="icon">
                <img v-if="item.entryExitType==='1'" src="../../../../../../assets/images/custom-screen/in.png" alt="" />
                <img v-else src="../../../../../../assets/images/custom-screen/out.png" alt="" />
              </div>
              <div class="desc" :class="{green:item.entryExitType==='1',red:item.entryExitType==='2'}">{{ item.entryExitType==='1'?'进场':'出场' }}</div>
              <div class="time">{{ item.recordTime }}</div>
              <div class="device">{{ item.deviceName }}</div>
            </div>
          </div>
          <div class="bottomInfo">
            <div class="temperature"> <span v-if="item.personTemperature&&item.personTemperature>0">{{ item.personTemperature }}℃</span></div>
            <div v-if="item.nucleicTestPointName" class="place">
              <div class="address">核酸检测地点：{{ item.nucleicTestPointName }}</div>
              <div class="time">核酸检测时间：{{ item.nucleicTestTime }} </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    personList: {
      type: Array,
      default: () => { return [] }
    }
  },
  data() {
    return {
      personAvatar: require('../../../../../../assets/images/new-screen/face.png')
    }
  },
  computed: {
    listFontSize() {
      const px = Math.ceil(12 / window.devicePixelRatio)
      return px
    },
    titleFontSize() {
      const px = Math.ceil(18 / window.devicePixelRatio)
      return px
    }
  },
  created() {
  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>
.ProjectInfo {
  width: 462px;
  height: 842px;
  position: relative;
  .title{
    color: #fff;
    padding-left: 10px;
    padding-top: 14px;
  }
  .info{
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    .list{
      color: #fff;
      padding: 0 4%;
      .item{
        background: rgba(0, 82, 217, 0.498039215686275);
        width: 100%;
        margin: 0 auto;
        margin-bottom: 10px;
        border-radius: 10px;
        padding: 12px 10px;
        .topInfo{
          display: flex;
        }
        .bottomInfo{
          display: flex;
          align-items: center;
          .temperature{
            width: 82px;
            text-align: center;
          }
          .place{
            >div{
              line-height: 1.6;
            }
          }

        }
        .img{
          width: 68px;
          height: 68px;
          img{
            width: 100%;
            height: 100%;
            display: block;
            object-fit: cover;
          }
        }
        .txt{
          // margin-top: 10px;
        }
        .userInfo{
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding-left: 14px;
          width: 20%;
        }
        .idenInfo{
          padding-left: 14px;
          flex: 1;
        }
        .inOutInfo{
          line-height: 1.4;
          text-align: center;
          .icon{
            width: 20px;
            height: 15px;
            margin: 0 auto;
            img{
              width: 100%;
            }
          }
          .desc{
            line-height: 1.5;
          }
          .red{
            color: #D61B1F;
          }
          .green{
            color: #00CC00;
          }
        }
      }
    }
  }
}
</style>
